import React from 'react';
import cn from 'classnames';
import Debounce from 'react-debounce-component';
import { CSSTransition } from 'react-transition-group';
import { ScalableFontSizeInput } from 'swag-client-common/components/partials/scalable-font-size-input';
import { HiddenLabel } from 'swag-client-common/components/hidden-label';
import errorAnimationClasses from './fast-appear.anim.scss';
import classes from './select-cart-items-header.scss';
export function SelectCartItemsHeaderComponent({
  currentBoxesQuantity,
  minQuantity,
  isEditMode,
  currentBoxesQuantityError,
  isDisableNextButton,
  onChangeQuantity,
  onNextClick,
  isAddonStepRestricted
}) {
  const isRender = !isAddonStepRestricted && isEditMode;
  const onClick = () => {
    if (!isDisableNextButton) {
      onNextClick();
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.header
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.text
  }, "I would like to order"), /*#__PURE__*/React.createElement(HiddenLabel, {
    htmlFor: "totalQuantity",
    label: "Quantity:"
  }), /*#__PURE__*/React.createElement(ScalableFontSizeInput, {
    value: currentBoxesQuantity,
    onChange: e => onChangeQuantity(parseInt(e.target.value, 10) || 0),
    className: classes.input,
    minFontSize: 20,
    maxFontSize: 38,
    maxDigits: 6,
    id: "totalQuantity",
    "data-input": "BoxTotalInput"
  }), /*#__PURE__*/React.createElement("span", {
    className: classes.text
  }, "boxes"), /*#__PURE__*/React.createElement("span", {
    className: classes.minQty
  }, "(Min qty: ", minQuantity, ")"), /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: errorAnimationClasses,
    in: !!currentBoxesQuantityError,
    timeout: 250,
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement(Debounce, null, /*#__PURE__*/React.createElement("div", {
    className: classes.error
  }, currentBoxesQuantityError))), isRender ? /*#__PURE__*/React.createElement("span", {
    "data-button": "ViewAddons",
    onClick: onClick,
    className: cn(classes.viewStepAtEditModeBtn, {
      [classes.viewStepAtEditModeBtnDisabled]: isDisableNextButton
    })
  }, "View Addons") : null));
}